import { createSelector } from 'reselect';
import { appendPath, getValue } from '@truqc/content-path';
import { getContent, getStaticContent } from './simpleSelectors';
import formatPropertySelectorCreator from './formatPropertySelectorCreator';
const getProjectsContentPathRel = formatPropertySelectorCreator('projectsContentPath');
const getParentContentPath = (state, props) => props.parentContentPath || '/';
const getPropsProjectsValue = (state, props) => props.projectsValue;

/**
 * Value at format.projectsContentPath (relative to parentContentPath).
 * Shape is typically a map of uuid -> { title, uuid }.
 */
export default createSelector([getContent, getStaticContent, getParentContentPath, getProjectsContentPathRel, getPropsProjectsValue], (content, staticContent, parentContentPath, projectsRel, propsProjectsValue) => {
  if (propsProjectsValue !== undefined) {
    return propsProjectsValue;
  }
  if (projectsRel === undefined || projectsRel === null || projectsRel === '') {
    return undefined;
  }
  const fullPath = appendPath(parentContentPath, projectsRel);
  let projectsValue = getValue(fullPath, content);
  if (projectsValue !== undefined) {
    return projectsValue;
  }
  projectsValue = getValue(fullPath, staticContent);
  return projectsValue;
});